import { render } from "./LieuEXAM.vue?vue&type=template&id=dce64e44&scoped=true"
import script from "./LieuEXAM.vue?vue&type=script&lang=js"
export * from "./LieuEXAM.vue?vue&type=script&lang=js"

import "./LieuEXAM.vue?vue&type=style&index=0&id=dce64e44&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce64e44"]])

export default __exports__